import { Link } from "react-router-dom";

interface PageHeaderProps {
    /** Where the back link goes. Defaults to the search page. */
    backTo?: string;
    backLabel?: string;
}

/**
 * Header for the pages below the search box.
 *
 * Both inner pages previously had no route back: on a phone, where there is no
 * visible browser chrome in an installed PWA, that left people stranded with no
 * way to start another search.
 */
export default function PageHeader({ backTo = "/", backLabel = "New search" }: PageHeaderProps) {
    return (
        <header className="page-header">
            <Link to={backTo} className="back-link">
                <span aria-hidden="true">←</span> {backLabel}
            </Link>
            <Link to="/" className="header-brand" aria-label="TopCat home">
                <img src="/topcat-face.png" alt="" width={32} height={28} />
                <span>TopCat</span>
            </Link>
        </header>
    );
}
